import React from "react";
import { TickerViewport, TickerTrack } from "../pages/SorteoParticipants.styles";

// Continuous vertical list driven only by a CSS animation on the compositor.
// When there are more rows than fit, the list is rendered twice and the track
// scrolls exactly one copy, so the jump back to the start is invisible.
const ParticipantTicker = ({ items, getKey, renderRow, visibleRows = 12, secondsPerRow = 1 }) => {
  const animated = items.length > visibleRows;
  const style = {
    '--ticker-visible': visibleRows,
    '--ticker-rows': items.length,
    '--ticker-duration': `${items.length * secondsPerRow}s`,
  };

  return (
    <TickerViewport>
      <TickerTrack style={style} data-animated={animated} data-testid="participant-ticker">
        {items.map(item => (
          <React.Fragment key={getKey(item)}>{renderRow(item)}</React.Fragment>
        ))}
        {animated && items.map(item => (
          <div key={`copy-${getKey(item)}`} aria-hidden="true" style={{ display: 'contents' }}>
            {renderRow(item)}
          </div>
        ))}
      </TickerTrack>
    </TickerViewport>
  );
};

export default ParticipantTicker;
